
import React, { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import '../../assets/css/admin.css';

function AdminNav() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleDropdown2 = () => setDropdownOpen2(!dropdownOpen2);

  return (
      <Navbar className="navbar" expand="md">
        <NavbarBrand href="/admin" className="navbar-brand">WOW Cloud Network Admin Panel</NavbarBrand>
        <Nav className="ml-auto" navbar>
        <NavItem>
          <NavLink href="/admin">Dashboard</NavLink>
        </NavItem>
          
        <Dropdown nav isOpen={dropdownOpen2} toggle={toggleDropdown2}>
            <DropdownToggle nav caret className="nav-link">
              Tools
            </DropdownToggle>
            <DropdownMenu right className="dropdown-menu-dark">
              <DropdownItem href="/admin/tools/transaction-lookup">Transaction Lookup</DropdownItem>
              <DropdownItem href="/admin/tools/transaction-dispute-lookup">Transaction Dispute Lookup </DropdownItem>
              <DropdownItem href="/admin/tools/customer-lookup">Customer Lookup </DropdownItem>
              <DropdownItem href="/admin/tools/locknote-lookup">Lock Note Lookup </DropdownItem>
              <DropdownItem href="/admin/tools/user-management">User Management</DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle nav caret className="nav-link">
              Reports
            </DropdownToggle>
            <DropdownMenu right className="dropdown-menu-dark">
              <DropdownItem href="/admin/reports/all-transactions">All Transactions</DropdownItem>
              <DropdownItem href="/admin/reports/payments">Payments</DropdownItem>
              <DropdownItem href="/admin/reports/customer-processor-status">Customer Processor Status</DropdownItem>
              <DropdownItem href="/admin/reports/top-bandwidth">Top Bandwidth Consumers</DropdownItem>
              <DropdownItem href="/admin/reports/processor-projection">Processor Projections</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <NavItem>
            <NavLink href="/admin/logout">Logout</NavLink>
          </NavItem>
        </Nav>
      </Navbar>
  );
}

export default AdminNav;